import { ChatMarkdown } from "@/core/components/chat-markdown";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import type { Rules } from "./types";

export const RulesView = ({
  title,
  rules,
  empty,
}: {
  title: string;
  rules: Rules | null;
  empty: string;
}) => (
  <section className="flex min-h-full min-w-0 flex-col gap-3 p-4">
    <h2 className="font-semibold">{title}</h2>
    {rules?.rules ? (
      <ChatMarkdown>{rules.rules}</ChatMarkdown>
    ) : (
      <Empty className={emptyStateVariants({ layout: "inline" })}>
        <EmptyHeader>
          <EmptyDescription>{empty}</EmptyDescription>
        </EmptyHeader>
      </Empty>
    )}
  </section>
);
